module.exports = __webpack_public_path__ + "img/thumb_22.4c57a3a8.jpg";